
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'KIcon',
  props: {
    // icon样式
    iconname: {
      type: String,
      default: 'loading'
    },
    // icon
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    loadingClass(): string {
      return this.loading ? 'k-icon-loading' : ''
    }
  }
})
